import React from 'react';
import './style.sass';
import { Footer } from 'pages/Footer';
import { MenuCredito } from 'components/menuCredito';

export default function SolicitarPermisosDesktop() {
    return (
        <>
            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />

                    <div className="contenido">
                        <div className="tituloPage">
                            <p>Permisos</p>
                        </div>
                        <div className="boxGeneralHomeDesk">

                        </div>
                    </div>
                </section>
            </main>
            <Footer type="complete"/>
        </>
    )
}